import { IconName } from '@infotech-soe/erp-ui-kit';
import { CommandHotKey, THotKey } from '@infotech-soe/metaschema';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';

import CategoryCommand from './CategoryCommand';

class SettingsCommand extends CategoryCommand<void> {
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.SETTINGS,
    };
  }

  public getIcon(): IconName {
    return 'config';
  }

  public getHotKey(): THotKey {
    return CommandHotKey.Settings;
  }
}

export default SettingsCommand;
